<template>
  <div :class="{ 'inline-styled': isInline }">
    <SCThreeCheckbox
      :id="htmlId"
      label-text="Use Main Chart Symbol As Baseline"
      v-model:checkbox-value="chartStore.useMainChartSymbolAsBaseline"
      :is-dark-font="true"
      :is-square="true"
      :title-font-size="14"
      :icon-size="14"
    />
  </div>
</template>

<script lang="ts" setup>
  import { toRefs } from 'vue';
  import { useChartStore } from '@/stores/chartStore';
  import SCThreeCheckbox from '@/components/checkboxes/SCThreeCheckbox.vue';

  const chartStore = useChartStore();
  const props = defineProps<{
    htmlId: string;
    isInline: boolean;
  }>();
  const { htmlId, isInline } = toRefs(props);
</script>

<style scoped>
  div {
    display: inline-block;
  }

  .inline-styled {
    display: inline-flex;
    align-items: center;
    height: var(--sc3-compact-height);
  }
</style>
